import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './multilogin.scss'
import studentImage from 'src/assets/images/groupstudy.jpg'
import parentImage from 'src/assets/images/groupstudy.jpg'
import counselorImage from 'src/assets/images/Counseling.jpg'
import tutorImage from 'src/assets/images/on1tutoring.jpg'
import librarianImage from 'src/assets/images/Counseling.jpg'
import journeyImage from 'src/assets/images/1journey.png'
import bam from 'src/assets/images/bussiness.jpg'
import { Spin, message } from 'antd'

const PORTALS = [
  { value: 'Student', label: 'Student', desc: 'Learner dashboard', img: studentImage },
  { value: 'Parent', label: 'Parent', desc: 'Guardian view', img: parentImage },
  { value: 'Counselor', label: 'Counselor', desc: 'Counseling workspace', img: counselorImage },
  { value: 'Tutor', label: 'Tutor', desc: 'Tutoring hub', img: tutorImage },
  { value: 'Librarian', label: 'Library', desc: 'Library & internships', img: librarianImage },
  { value: 'BAMAdmin', label: 'BAM', desc: 'Business admin', img: bam },
  { value: 'Mentor', label: 'Mentor', desc: 'Mentorship hub', img: tutorImage },
]

// Admin-Proxy-Login allowlist (backend Admin-authorized demo login). Updated 2026-09-04.
const emailMap = {
  Student: 'student.1journey@gmail.com',
  Parent: 'parent.1journey@gmail.com',
  Counselor: 'counselor.1journey@gmail.com',
  Tutor: 'tutor.1journey@gmail.com',
  Librarian: 'librarian.1journey@gmail.com',
  BAMAdmin: 'bam.1journey@gmail.com',
  Mentor: 'ethancarter@yopmail.com',
}

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

const MultiLogin = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(null)

  // Capture the admin JWT once so we can proxy into any role repeatedly, even after
  // switching roles and returning to the picker. Only the Admin token can proxy-login.
  useEffect(() => {
    const currentRole = localStorage.getItem('role')
    const token = localStorage.getItem('token')
    if (token && currentRole === 'Admin') {
      localStorage.setItem('adminToken', token)
    }
  }, [])

  const handleRedirect = async (event) => {
    event.preventDefault()
    const attributeValue = event.currentTarget.getAttribute('data-value')

    setLoading(attributeValue)

    try {
      // Admin proxies into the selected demo role using the admin JWT (backend
      // Admin-Proxy-Login, token valid ~1 hour). Replaces the old hardcoded password login.
      const adminToken = localStorage.getItem('adminToken') || localStorage.getItem('token')
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL_API}/Account/Admin-Proxy-Login`,
        { email: emailMap[attributeValue] },
        { headers: { Authorization: `Bearer ${adminToken}` } },
      )

      const { token, userId, roles } = response.data

      localStorage.setItem('token', token)
      localStorage.setItem('userId', userId)
      localStorage.setItem('roles', JSON.stringify(roles))
      // AppContent decides the dashboard from the singular 'role' key, so the picker
      // must set it to the chosen portal (the normal login does the same via useLogin).
      localStorage.setItem('role', attributeValue)
      localStorage.setItem('AdminProxyScreen', attributeValue)

      // Keep the card in its loading state until the redirect fires (do not clear it
      // in a finally, or the cards re-enable for ~1s and allow a second portal login).
      setTimeout(() => {
        window.location.href = `/${attributeValue.toLowerCase()}Dashboard`
      }, 1000)
    } catch (error) {
      console.error('Proxy login error:', error)
      message.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          'Unable to open that portal. Please try again.',
      )
      setLoading(null)
    }
  }

  const handleLogout = () => {
    localStorage.setItem('logout', true)
    localStorage.clear()
    navigate('/login')
  }

  const handleRegister = () => {
    navigate('/Register', {
      state: {
        fromAdmin: true,
        returnTo: '/multiLogin',
      },
    })
  }

  return (
    <div className="mlx">
      <div className="mlx__aurora" aria-hidden="true">
        <span className="mlx__orb mlx__orb--a" />
        <span className="mlx__orb mlx__orb--b" />
        <span className="mlx__orb mlx__orb--c" />
        <span className="mlx__grid" />
      </div>

      <header className="mlx__top">
        <div className="mlx__brand">
          <img src={journeyImage} alt="1Journey" />
        </div>
        <div className="mlx__actions">
          <button type="button" className="mlx__btn mlx__btn--ghost" onClick={handleRegister}>
            Tutor, Counselor &amp; Mentor Registration
          </button>
          <button type="button" className="mlx__btn mlx__btn--solid" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <main className="mlx__body">
        <div className="mlx__head">
          <span className="mlx__eyebrow">Admin access</span>
          <h1 className="mlx__title">Choose a portal</h1>
          <p className="mlx__sub">Open any dashboard to continue.</p>
        </div>

        <div className="mlx__grid-cards">
          {PORTALS.map((p) => (
            <button
              key={p.value}
              type="button"
              className={`mlx__card${loading === p.value ? ' is-loading' : ''}`}
              data-value={p.value}
              onClick={handleRedirect}
              disabled={loading !== null}
            >
              <span className="mlx__photo" style={{ backgroundImage: `url(${p.img})` }}>
                <span className="mlx__shade" />
              </span>
              <span className="mlx__meta">
                <span className="mlx__text">
                  <span className="mlx__name">{p.label}</span>
                  <span className="mlx__desc">{p.desc}</span>
                </span>
                <span className="mlx__go">
                  {loading === p.value ? <Spin size="small" /> : <ArrowIcon />}
                </span>
              </span>
            </button>
          ))}
        </div>
      </main>
    </div>
  )
}

export default MultiLogin
